/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import axiosInstance from "api/axiosInstance";
import MDButton from "components/MDButton";
import { useState, useEffect, useCallback } from "react";
import { API_URL } from "../../../url";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
export default function Data() {
  const [BlogData, setBlogData] = useState(null);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const fetchData = useCallback(async () => {
    try {
      const response = await fetch(`${API_URL}/blog?page=${page}&pageSize=${pageSize}`);
      const data = await response.json();

      if (data?.success) {
        setBlogData(data?.data);
        setTotalCount(data?.totalCount);
      } else {
        console.error("Error fetching data:", data);
      }
    } catch (error) {
      console.error("Fetch error:", error);
    }
  }, [page, pageSize]);

  useEffect(() => {
    if (page) {
      fetchData();
    }
  }, [fetchData, page]);
  const deleteItem = async (id) => {
    const confirmed = window?.confirm("Are you sure want to delete?");

    if (confirmed) {
      const res = await axiosInstance.delete(`/blog/action/delete/${id}`, {});

      if (res?.data?.success) {
        toast.success(res?.data?.message);
        fetchData();
      }
    }
  };
  function getDateOnly(dateString) {
    const date = new Date(dateString);
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
    };
    return date.toLocaleDateString(undefined, options);
  }

  const Author = ({ name }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name?.slice(0, 30)}
        </MDTypography>
      </MDBox>
    </MDBox>
  );

  const Email = ({ title }) => (
    <MDBox lineHeight={1} textAlign="left">
      <MDTypography display="block" variant="caption" color="text" fontWeight="medium">
        {title}
      </MDTypography>
    </MDBox>
  );
  const rows = BlogData
    ? BlogData.map((blog) => ({
        Title: <Author name={blog.title} />,
        Author: <Email title={blog.author} />,

        Category: (
          <MDTypography component="span" variant="caption" color="text" fontWeight="medium">
            {blog.categories}
          </MDTypography>
        ),

        Date: (
          <MDTypography component="span" variant="caption" color="text" fontWeight="medium">
            {getDateOnly(blog.createdAt)}
          </MDTypography>
        ),
        Action: (
          <MDBox lineHeight={1} textAlign="left" display="flex" alignItems="center">
            <MDButton
              variant="gradient"
              color="info"
              fullWidth
              onClick={() => deleteItem(blog?._id)}
            >
              Delete
            </MDButton>

            <MDBox ml={2}>
              <Link to={"/post-blog"} state={{ slug: blog?.slug }}>
                <MDButton variant="gradient" color="info" fullWidth>
                  Edit
                </MDButton>
              </Link>
            </MDBox>
            <MDBox ml={2}>
              <Link to={"/blog-details"} state={{ slug: blog?.slug }}>
                <MDButton variant="gradient" color="info" fullWidth>
                  View
                </MDButton>
              </Link>
            </MDBox>
          </MDBox>
        ),
      }))
    : [];
  return {
    columns: [
      { Header: "Title", accessor: "Title", width: "20%", align: "left" },
      { Header: "Author", accessor: "Author", align: "left" },
      { Header: "Category", accessor: "Category", width: "30%", align: "center" },
      { Header: "Date", accessor: "Date", align: "center" },
      { Header: "Action", accessor: "Action", align: "center" },
    ],

    rows: rows,
    totalCount: totalCount,
    pagecount: pageSize,
    setPage: setPage,
  };
}
